import React from 'react'
import './index.scss'

const ContactUsFooter = () => (
    <div className="contact-us-footer">
        <div className="email-block">
            <h5>For any questions related to:</h5>
            <ul>
                <li>
                    Press Inquiries and Interview Requests: <a href="mailto:press@themlc.com">press@themlc.com </a>
                </li>
                <li>
                    Monthly Usage Reporting: <a href="mailto:dsp.relations@themlc.com">dsp.relations@themlc.com </a>
                </li>
                <li>
                    Marketing: <a href="mailto:marketinginfo@themlc.com">marketinginfo@themlc.com </a>
                </li>
                <li>
                    International Relations: <a href="mailto:international@themlc.com">international@themlc.com </a>
                </li>
                <li>
                    Data Quality Initiative (DQI): <a href="mailto:data.quality@themlc.com">data.quality@themlc.com </a>
                </li>
            </ul>
        </div>
    </div>
)

export default ContactUsFooter
